import { render, staticRenderFns } from "./TheLoader.vue?vue&type=template&id=18baaa8d&scoped=true&"
import script from "./TheLoader.vue?vue&type=script&lang=js&"
export * from "./TheLoader.vue?vue&type=script&lang=js&"
import style0 from "./TheLoader.vue?vue&type=style&index=0&id=18baaa8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18baaa8d",
  null
  
)

export default component.exports